import { RefObject, useLayoutEffect } from 'react';
import * as d3 from 'd3';
import { isNumber } from 'lodash';
import { texturePatternIdsByTextureIndex } from '@ardoq/icons';

const getTexturePatternIdByIndex = (index: number) => {
  const textureIndex =
    index > texturePatternIdsByTextureIndex.length
      ? index % (texturePatternIdsByTextureIndex.length + 1)
      : index;

  if (!textureIndex) {
    return;
  }

  return texturePatternIdsByTextureIndex[textureIndex - 1];
};

const TEXTURE_DATA_ATTRIBUTE = 'data-texture-index';

export const useTexture = (
  componentRef: RefObject<HTMLElement | null>,
  textureIndex: number,
  width?: number
) => {
  useLayoutEffect(() => {
    const existingTexture = componentRef.current?.querySelector('svg.texture');
    existingTexture?.remove();

    if (!componentRef.current || !componentRef.current.offsetHeight) {
      return;
    }

    const textureWidth =
      isNumber(width) && width > 0 ? width : componentRef.current.offsetWidth;
    const textureHeight = componentRef.current.offsetHeight - 1;

    const svg = d3
      .select(componentRef.current)
      .append('svg')
      .attr(TEXTURE_DATA_ATTRIBUTE, textureIndex)
      .attr('class', 'texture')
      .attr('width', textureWidth)
      .attr('height', textureHeight);

    svg
      .append('rect')
      .attr(TEXTURE_DATA_ATTRIBUTE, textureIndex)
      .attr('x', 0)
      .attr('width', textureWidth)
      .attr('y', 0)
      .attr('height', textureHeight)
      .style('fill', `url(#${getTexturePatternIdByIndex(textureIndex)})`);
  }, [componentRef, textureIndex, componentRef.current?.offsetWidth, width]);
};
